{
  "launching": "Signing you in...",
  "changeLanguage": "Change Language",
  "logOut": "Log out"
}
